import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Image.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Image extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            name: {},
            url: {},
            size: {}
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Image] organizationId is mandatory');
        }
        return `/sites/organizations/${organizationId}/gallery`;
    }
}
